import { render, staticRenderFns } from "./list.vue?vue&type=template&id=6a7915a7"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports